import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const API_PATH = '/yt-song/web/beat-server-setting';

class BeatServerSettingPage extends Component {
    state = {
        preferredServer: 'PRIMARY',
        savedServer: 'PRIMARY',
        loading: true,
        loaded: false,
        saving: false,
        error: null
    };

    componentDidMount() {
        this.loadSetting();
    }

    loadSetting = async () => {
        this.setState({ loading: true, loaded: false, error: null });
        try {
            const response = await axios.get(global.config.apiDomain + API_PATH);
            const result = response.data;
            if (!result || result.status !== 'OK' || !result.data ||
                !['PRIMARY', 'B2'].includes(result.data.preferredServer)) {
                throw new Error(result && result.message || "Không thể tải cấu hình server beat");
            }
            this.setState({
                loaded: true,
                preferredServer: result.data.preferredServer,
                savedServer: result.data.preferredServer
            });
        } catch (error) {
            this.setState({ error: error.response && error.response.data && error.response.data.message ||
                error.message || "Không thể tải cấu hình server beat" });
        } finally {
            this.setState({ loading: false });
        }
    };

    saveSetting = async () => {
        const { preferredServer, savedServer } = this.state;
        if (preferredServer === savedServer) return;
        if (!window.confirm("Áp dụng lựa chọn server beat cho toàn hệ thống?")) return;
        this.setState({ saving: true, error: null });
        try {
            const response = await axios.post(global.config.apiDomain + API_PATH, { preferredServer });
            const result = response.data;
            if (!result || result.status !== 'OK' || !result.data ||
                !['PRIMARY', 'B2'].includes(result.data.preferredServer)) {
                throw new Error(result && result.message || "Không thể lưu cấu hình server beat");
            }
            this.setState({
                preferredServer: result.data.preferredServer,
                savedServer: result.data.preferredServer
            });
            toast.success("Đã lưu cấu hình server beat");
        } catch (error) {
            this.setState({ error: error.response && error.response.data && error.response.data.message ||
                error.message || "Không thể lưu cấu hình server beat" });
        } finally {
            this.setState({ saving: false });
        }
    };

    render() {
        const { preferredServer, savedServer, loading, loaded, saving, error } = this.state;
        return (
            <div className="container py-4">
                <h2>{"Cấu hình server beat"}</h2>
                <p>{"Chọn server ưu tiên cho beat iKara và Yokara. Beat không có link B2 vẫn dùng server chính."}</p>
                {error && <div className="alert alert-danger" role="alert">{error}</div>}
                <button className="btn btn-outline-secondary mb-3" onClick={this.loadSetting}
                    disabled={loading || saving}>{"Tải lại"}</button>
                {!loading && loaded && (
                    <div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="beatServer"
                                id="beatServerPrimary" value="PRIMARY" checked={preferredServer === 'PRIMARY'}
                                disabled={saving}
                                onChange={event => this.setState({ preferredServer: event.target.value })} />
                            <label className="form-check-label" htmlFor="beatServerPrimary">
                                {"Server chính (Primary)"}
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="beatServer"
                                id="beatServerB2" value="B2" checked={preferredServer === 'B2'}
                                disabled={saving}
                                onChange={event => this.setState({ preferredServer: event.target.value })} />
                            <label className="form-check-label" htmlFor="beatServerB2">
                                {"Server B2"}
                            </label>
                        </div>
                        <button className="btn btn-primary mt-3" onClick={this.saveSetting}
                            disabled={saving || preferredServer === savedServer}>
                            {saving ? "Đang lưu..." : "Lưu"}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default BeatServerSettingPage;
